<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-app>
      <div v-if="auth">
        <v-navigation-drawer :mini-variant.sync="mini"
                             v-model="drawer"
                             clipped
                             fixed
                             dark
                             app
                             class="darkTuGps"
        >
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>Usuario: {{ this.$store.state.idUser }}</v-list-tile-title>
              </v-list-tile-content>
              <v-btn
                  v-if="mini "
                  @click.stop="mini = !mini"
                  color="black"
                  fixed
                  class="noBackgorun"
                  style="left:50%;"
                  flat
                  fab
              >
                <v-icon>chevron_right</v-icon>
              </v-btn>
            </v-list-tile>
          </v-list>
          <br>
          <!-- Rol Administrador -->
          <v-list v-if="$store.getters.isAdmin">
            <v-list-group
                v-if="$store.getters.isAdmin"
                v-for="item in isMobile()?itemsMobile:items"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
                :append-icon="item.appendIcon">

              <template v-slot:activator v-if="$store.getters.isAdmin">
                <v-list-tile router :to="item.route">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                  v-if="$store.getters.isAdmin"
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  router :to="subItem.route"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
          <!-- Rol Usuario -->
          <v-list v-else-if="$store.getters.isUser">
            <v-list-group
                v-for="item in itemsUser"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
                :append-icon="item.appendIcon">

              <template v-slot:activator>
                <v-list-tile router :to="item.route">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  router :to="subItem.route"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
          <!-- Rol Chofer -->
          <v-list v-else-if="$store.getters.isChofer">
            <v-list-group
                v-for="item in itemsChofer"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
                :append-icon="item.appendIcon">

              <template v-slot:activator>
                <v-list-tile router :to="item.route">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  router :to="subItem.route"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
          <!-- Rol Administrador de Flota -->
          <v-list v-else-if="$store.getters.isFlota">
            <v-list-group
                v-for="item in itemsFlota"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
                :append-icon="item.appendIcon">

              <template v-slot:activator>
                <v-list-tile router :to="item.route">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  router :to="subItem.route"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
          <!-- Rol Instalador -->
          <v-list v-else-if="$store.getters.isInstalador">
            <v-list-group
                v-for="item in itemsInstalador"
                :key="item.title"
                v-model="item.active"
                :prepend-icon="item.action"
                no-action
                :append-icon="item.appendIcon">

              <template v-slot:activator>
                <v-list-tile router :to="item.route">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>

              <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  router :to="subItem.route"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-icon>{{ subItem.action }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </v-list>
        </v-navigation-drawer>
        <!-- Header -->
        <v-toolbar
            dark
            color="nav_background_color"
            dense
            fixed
            clipped-left
            app
        >
          <v-toolbar-side-icon class="yellowTuGps" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
          <v-toolbar-title class="yellowTuGps" v-if="!isMobile()">
            <img src="https://imagenes-tugps.s3.amazonaws.com/logo.png" alt="" width="115px" style="padding-top: 4px">
          </v-toolbar-title>
          <v-toolbar-title class="yellowTuGps" v-if="isMobile()">
            <img src="https://imagenes-tugps.s3.amazonaws.com/logo.png" alt="" width="115px" style="padding-top: 4px">
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-btn icon @click.stop="dialogPassword = true" v-if="!isMobile()">
            <v-icon>more_vert</v-icon>
          </v-btn>
          <!--          <v-btn icon @click.stop="menu = true" >-->
          <!--            <v-icon >more_vert</v-icon>-->
          <!--            <v-menu v-model="menu" offset-y >-->
          <!--             <v-list>-->
          <!--                <v-list-tile>-->
          <!--                  <v-list-tile-title><div @click.stop="dialogPassword = true">Cambiar Contraseña</div></v-list-tile-title>-->
          <!--                </v-list-tile>-->
          <!--              </v-list>-->
          <!--            </v-menu>-->
          <!--          </v-btn>-->

          <v-tooltip bottom v-if="!isMobile()">
            <v-btn style="z-index: 100"
                   fab dark
                   small @click="$store.getters.isAdmin?$router.push({name: 'configuration',action: 'settings_applications'}):$router.push({name: 'alert',action: 'settings_applications'}),  message=false; "
                   slot="activator"
                   :color="this.message?'red':'primary'">
              <v-icon dark>notifications</v-icon>
            </v-btn>
            <span>Notificaciones</span>
          </v-tooltip>
          <v-tooltip bottom v-if="!isMobile()">
            <v-btn
                fab dark
                small @click="dialogPerfil=true"
                slot="activator"
                color="primary">
              <v-icon dark>perm_identity</v-icon>
            </v-btn>
            <span>Perfil</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isMobile()">
            <v-btn
                fab dark
                small @click="dialogCall=true"
                slot="activator"
                color="primary">
              <v-icon dark>call</v-icon>
            </v-btn>
            <span>Llamar TU GPS</span>
          </v-tooltip>
          <a @click="closeSession" v-if="!isMobile()">Salir</a>
        </v-toolbar>

        <!-- Router Components-->
        <v-content>
          <router-view/>
        </v-content>

        <!-- Generic Error -->
        <v-dialog v-model="this.$store.state.dialogError" max-width="500px">
          <v-card>
            <v-card-title>
              {{ this.$store.state.dialogErrorHeader != '' && this.$store.state.dialogErrorHeader != null ? this.$store.state.dialogErrorHeader : "Error en la aplicación" }}
            </v-card-title>
            <v-card-text>
              Detalle: {{ this.$store.state.dialogErrorMessage }}
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" flat @click.stop="closeError">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Dialog Password -->
        <v-dialog v-model="dialogPassword" max-width="500px">
          <v-card>
            <v-card-title>
              <span>Cambiar Contraseña</span>

              <v-form v-model="valid">
                Ingrese su nueva contraseña y la confirmación de la misma
                <v-text-field prepend-icon="lock" :rules="newPasswordRules" name="Nueva Contraseña"
                              label="Nueva Contraseña" type="password"
                              v-model="newPassword"></v-text-field>
                <v-text-field prepend-icon="lock" :rules="newPasswordRules"
                              name="Confirme su Nueva Contraseña" label="Confirme su Nueva Contraseña"
                              type="password" v-model="newPasswordConfirmation"
                              v-on:keyup.enter="changePassword"></v-text-field>
              </v-form>
            </v-card-title>
            <v-card-actions>
              <v-btn color="primary" flat :disabled="!valid" @click="changePassword">Cambiar</v-btn>
              <v-btn color="primary" flat @click.stop="dialogPassword=false" @click="cleanPasswordChange">
                Cancelar
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-alert v-model="alert" color="error" dismissible>
            {{ error }}
          </v-alert>
        </v-dialog>
        <v-dialog
            v-model="dialogPerfil"
            width="500px" hide-overlay transition="dialog-bottom-transition"
            scrollable>
          <v-card tile>
            <v-toolbar card dark color="nav_background_color">
              <v-btn icon dark @click.native="dialogPerfil = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Editar Perfil</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="valid">
                <div id="app" align="center">
                  <img :src="previewImage" class="uploading-image" width="100px" height="100px"/>
                  <br>
                  <input type="file" accept="image/jpeg" @change=uploadImage>
                  <br>
                  <br>
                </div>
                <v-layout>
                  <v-flex xs12 sm6 offset-sm4>
                    <div>
                      <v-btn class="btn-rounded"
                             @click="saveData" large color="primary">Guardar
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
        <v-dialog
            v-model="dialogCall" persistent
            width="500px" overlay-opacity transition="dialog-bottom-transition"
            scrollable>
          <v-card tile>
            <v-toolbar card dark color="nav_background_color">
              <v-btn icon dark @click.native="dialogCall = false">
                <v-icon>close</v-icon>
              </v-btn>
              <v-toolbar-title>Contáctate con TU GPS</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form v-model="valid">
                <v-layout>
                  <v-flex xs12 sm6 offset-sm4>
                    <div position="center" style="padding-top: 8px">Llamada:</div>
                    <div>
                      <button class="buttonBorder">
                        <img
                            src="https://img.favpng.com/2/14/18/computer-icons-png-favpng-PzG7YbdR9b8LVAyhh4UxVicjf.jpg"
                            class="icon" style="height: 50px"/>
                        <a href="tel:0998704891">0998704891</a>
                      </button>
                    </div>
                    <div position="center" style="padding-top: 8px">Whatsapp:</div>
                    <div>
                      <button class="buttonBorder">
                        <img
                            src="https://cdn3.iconfinder.com/data/icons/2018-social-media-logotypes/1000/2018_social_media_popular_app_logo-whatsapp-512.png"
                            class="icon" style="height: 50px"/>
                        <a href="https://wa.me/593998704891" target="_blank">WhatsApp</a>
                      </button>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
          </v-card>
        </v-dialog>
      </div>
      <!-- No log In -->
      <div v-if="!auth">
        <router-view/>
        <v-dialog v-model="this.$store.state.dialogError" max-width="500px">
          <v-card>
            <v-card-title>
              {{ this.$store.state.dialogErrorHeader }}
            </v-card-title>
            <v-card-text>
              Detalle: {{ this.$store.state.dialogErrorMessage }}
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" flat @click.stop="closeError">Cerrar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div v-if="this.$store.state.progress" class="loading">
        <div class="progressIcon" style="">
          <v-progress-circular
              indeterminate
              color="white"
          ></v-progress-circular>
        </div>
        <div class="messageLoading">Por favor espere un momento...</div>
      </div>

    </v-app>
  </div>
</template>

<script>
import VueJwtDecode from 'vue-jwt-decode';
export default {
  data() {
    return {
      mini: false,
      drawer: false,
      fixed: false,
      menu: false,
      dialogPerfil: false,
      dialogCall: false,
      message: false,

      items: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'perm_identity',
          title: 'Usuarios',
          route: 'client',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'add_alert',
          title: 'Alertas',
          route: 'configuration',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'face',
          title: 'Ventas',
          route: 'sale',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },

      ],
      itemsMobile: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'perm_identity',
          title: 'Usuarios',
          route: 'client',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'add_alert',
          title: 'Alertas',
          route: 'configuration',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'face',
          title: 'Ventas',
          route: 'sale',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },

      ],
      itemsUser: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        // {
        //   action: 'add_alert',
        //   title: 'Alertas',
        //   route: 'alert',
        //   rol: 'user',
        //   appendIcon: null
        // },
        // {
        //   action: 'perm_identity',
        //   title: 'Perfil',
        //   route: 'start',
        //   rol: 'user',
        //   appendIcon: null
        // },
        // {
        //   action: 'question_answer',
        //   title: 'Comentarios',
        //   route: 'start1',
        //   rol: 'user',
        //   appendIcon: null
        // },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },
      ],
      itemsChofer: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'add_alert',
          title: 'Alertas',
          route: 'configuration',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },
      ],
      itemsFlota: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'add_alert',
          title: 'Alertas',
          route: 'configuration',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },
      ],
      itemsInstalador: [
        {
          action: 'track_changes',
          title: 'Dispositivos',
          route: 'device',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'add_alert',
          title: 'Alertas',
          route: 'configuration',
          rol: 'user',
          appendIcon: null
        },
        {
          action: 'logout',
          title: 'Cerrar sesión',
          route: 'closeSession',
          rol: 'user',
          appendIcon: null
        },
      ],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js',
      dialogPassword: false,
      newPassword: '',
      newPasswordConfirmation: '',
      error: '',
      alert: false,
      valid: false,
      newPasswordRules: [
        v =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/.test(v) ||
            'La constraseña deberá ser mínimo de 8 caracteres, contener mínimo 1 letra mayúscula y 1 carácter numérico'
      ],
      previewImage: "https://avatars-tupgps.s3.amazonaws.com/001-ambulance1.png",
      interval : ""

    };
  },
  computed: {
    auth() {
      if ( this.$store.getters.isAuthenticated ) {
        return true;
      } 
    },
    fechaActual() {
      var meses = new Array(
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
      );
      var f = new Date();
      return (
          f.getDate() + ' de ' + meses[f.getMonth()] + ' del ' + f.getFullYear()
      );
    },
  },
  methods: {
    saveData() {
      this.dialogPerfil = false
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e => {
        this.previewImage = e.target.result;
      };
    },
    closeSession() {
      sessionStorage.setItem('id_token', null);
      this.$store.state.authenticated = false;
      this.$router.push('/login');
      let state = this.$store.state;
      let newState = {};
      Object.keys(state).forEach(key => {
        newState[key] = null; // or = initialState[key]
      });
      this.$store.replaceState(newState);
      clearInterval(this.$store.state.intervalMap)
      this.deleteInterval()
    },
    closeError() {
      this.$store.state.dialogErrorMessage = "Se ha presentado un error en el aplicativo. Vuelva a intentarlo más tarde"
      this.$store.state.dialogErrorHeader = "Error en la aplicación",
          this.$store.state.dialogError = false;
    },
    changePassword() {
      if (this.checkNewPassword()) {
        this.$store.dispatch('changePassword', this.newPassword).then(
            response => {
              this.cleanPasswordChange();
            },
            error => {
              this.$store.state.dialogError = true;
            }
        );
        this.dialogPassword = false;
      }
    },
    checkNewPassword() {
      if (this.newPassword != this.newPasswordConfirmation) {
        this.error = 'La nueva contraseña no coincide con la confirmación.';
        this.alert = true;
        return false;
      }
      return true;
    },
    cleanPasswordChange() {
      this.newPassword = '';
      this.newPasswordConfirmation = '';
      this.dialogPassword = false;
      this.alert = false;
      this.valid = false;
    },
    playAudio() {
      var audio = new Audio('https://sonidos-tu-gps.s3.amazonaws.com/notificacion.mp3'); // path to file
      audio.play();
    },
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    getNewNotifications() {
      let search = ""
      if (this.$store.state.idUser !== "admin") {
        return
      }
      if (this.$store.state.deviceUser == '' || this.$store.state.deviceUser == null) {
        search = this.$store.state.idUser
      } else {
        search = this.$store.state.deviceUser.login
      }
      let queryParam = ''
      if(search === null){
        clearInterval(this.interval)
        return;
      }
      this.$store.dispatch('getDevicesByUserLoginNotLoad', search).then(response => {
        this.devices = []
        this.geoFences = []
        for (let i = 0; i < response.data.length; i++) {
          let object = JSON.parse(response.data[i].value)
          object.id = response.data[i].id
          object.selected = false
          object.user = response.data[i].user
          this.devices.push(object)
        }
        queryParam = "from=" + this.dateStart() + "&" + "to=" + this.dateEnd()
        this.$store.dispatch('getDevicesLocationTraccarAlarm', queryParam).then(response => {
            for (const notification of response.data) {
                if (notification.type == "deviceOnline" || notification.type == "deviceUnknown"|| notification.type == "deviceOffline" || notification.type == "deviceOverspeed" 
                  || notification.type == "deviceMoving"  || notification.type == "deviceStopped" || notification.type == "ignitionOff" || notification.type == "ignitionOn" 
                ) {
                  continue
                }
                  if (!this.message) {
                    this.playAudio();
                  }
                  this.message = true
                  return true
            }
        })
      })
      return false
    },
    dateStart(){
      let date = new Date();

      date.setTime(date.getTime() - (1 * 60 * 1000)); // Convert hours to milliseconds - 60 minutes to an hour, 60 seconds to a minute, 1000 milliseconds to a second

      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours()+"";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";


      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    dateEnd(){
      let date = new Date();
      var day = date.getDate() + "";
      var month = date.getMonth()+1 + "";
      var year = date.getFullYear() + "";
      var hour = date.getHours() + "";
      var minutes = date.getMinutes() + "";
      var seconds = date.getSeconds() + "";

      day = this.checkZero(day);
      month = this.checkZero(month);
      year = this.checkZero(year);
      hour = this.checkZero(hour);
      minutes = this.checkZero(minutes);
      seconds = this.checkZero(seconds);

      return year + "-" + month + "-" + day + "T" + hour + ":" + minutes + ":" + seconds+"-05";
    },
    checkZero(data){
      if(data.length === 1){
        data = "0" + data.toString();
      }
      return data;
    },
    deleteInterval() {
      clearInterval(this.$store.state.intervalMap)
      const highestIntervalId = window.setInterval(() => { }, 1000); // Get the highest interval ID
      for (let i = 0; i <= highestIntervalId; i++) {
        window.clearInterval(i); // Clear each interval
      }
    },
  },
  beforeCreate() {
    this.$store.state.changePassword = this.$route.query.changePassword;
    clearInterval(this.$store.state.intervalMap)
    clearInterval(this.interval)
    if ( localStorage.sessionStorageIdToken && localStorage.sessionStorageIdToken.length > 0 ) {
      this.$store.state.authenticated = true;
      sessionStorage.setItem("id_token",localStorage.sessionStorageIdToken);
      sessionStorage.setItem("token",localStorage.sessionStorageToken);
      let clientData = VueJwtDecode.decode(localStorage.sessionStorageIdToken);
      this.$store.state.idUser = clientData.sub;
      this.$store.state.roles = clientData.auth.split(",");
      this.$router.push('/device');
    }
  },
  created() {
    const self = this
    this.interval = setInterval(function(){
      self.message = self.getNewNotifications();
    }, 60000);
  },
  name: 'App'
};
</script>

<style>
@import "assets/themes/temas.css";

.v-treeview-node__label{
  display: none;
}
.text-tree-view {
  font-size: 13px !important;
  color: black;
  padding-left: 10px;
}
.v-treeview>.v-treeview-node--leaf {
  margin-left: 0px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue